import React, { useState } from "react";

import MovieCard from "./MovieCard";

const SearchMovies = () => {
  const [query, setQuery] = useState("");
  const [movies, setMovies] = useState([]);

  const searchMovies = async (e) => {
    e.preventDefault();

    const url = `https://api.themoviedb.org/3/search/movie?api_key=844dba0bfd8f3a4f3799f6130ef9e335&language=en-US&query=${query}&page=1&include_adult=false`;

    try {
      const res = await fetch(url);
      const data = await res.json();
      setMovies(data.results);
      setQuery("");
      // console.log(movies);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div>
        <form className='form' onSubmit={searchMovies}>
          <label htmlFor='query' className='label'>
            Movie Name
          </label>

          <input
            type='text'
            name='query'
            placeholder='Search Movie'
            className='input'
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <button type='submit' className='button'>
            Search
          </button>
        </form>
        <div className='card-list'>
          {movies
            .filter((movie) => movie.poster_path)
            .map((movie) => (
              <>
                <MovieCard movie={movie} />
              </>
            ))}
        </div>
      </div>
    </>
  );
};

export default SearchMovies;
